import __var_0__ from '@stdlib/vendor/events.js';
import __var_1__ from '@stdlib/vendor/debug.js';
import __var_2__ from '@stdlib/utils/keys';
import __var_3__ from '@stdlib/utils/define-property';
import __var_4__ from '@stdlib/utils/define-read-only-property';
import __var_5__ from '@stdlib/assert/is-plain-object';
import __var_6__ from '@stdlib/utils/copy';
import __var_7__ from '@stdlib/utils/inherit';
import __var_8__ from '@stdlib/utils/merge';
import __var_9__ from '@stdlib/random/base/minstd';
import __var_10__ from './view/view.js';
import __var_11__ from './defaults.js';
import __var_12__ from './props/x/set.js';
import __var_13__ from './props/x/get.js';
import __var_14__ from './props/y/set.js';
import __var_15__ from './props/y/get.js';
import __var_16__ from './props/labels/set.js';
import __var_17__ from './props/labels/get.js';
import __var_18__ from './props/is-defined/set.js';
import __var_19__ from './props/is-defined/get.js';
import __var_20__ from './props/colors/set.js';
import __var_21__ from './props/colors/get.js';
import __var_22__ from './props/line-style/set.js';
import __var_23__ from './props/line-style/get.js';
import __var_24__ from './props/line-opacity/set.js';
import __var_25__ from './props/line-opacity/get.js';
import __var_26__ from './props/line-width/set.js';
import __var_27__ from './props/line-width/get.js';
import __var_28__ from './props/symbols/set.js';
import __var_29__ from './props/symbols/get.js';
import __var_30__ from './props/symbols-size/set.js';
import __var_31__ from './props/symbols-size/get.js';
import __var_32__ from './props/symbols-opacity/set.js';
import __var_33__ from './props/symbols-opacity/get.js';
import __var_34__ from './props/width/set.js';
import __var_35__ from './props/width/get.js';
import __var_36__ from './props/height/set.js';
import __var_37__ from './props/height/get.js';
import __var_38__ from './props/padding-left/set.js';
import __var_39__ from './props/padding-left/get.js';
import __var_40__ from './props/padding-right/set.js';
import __var_41__ from './props/padding-right/get.js';
import __var_42__ from './props/padding-top/set.js';
import __var_43__ from './props/padding-top/get.js';
import __var_44__ from './props/padding-bottom/set.js';
import __var_45__ from './props/padding-bottom/get.js';
import __var_46__ from './props/x-min/set.js';
import __var_47__ from './props/x-min/get.js';
import __var_48__ from './props/x-max/set.js';
import __var_49__ from './props/x-max/get.js';
import __var_50__ from './props/y-min/set.js';
import __var_51__ from './props/y-min/get.js';
import __var_52__ from './props/y-max/set.js';
import __var_53__ from './props/y-max/get.js';
import __var_54__ from './props/x-scale/set.js';
import __var_55__ from './props/x-scale/get.js';
import __var_56__ from './props/y-scale/set.js';
import __var_57__ from './props/y-scale/get.js';
import __var_58__ from './props/x-tick-format/set.js';
import __var_59__ from './props/x-tick-format/get.js';
import __var_60__ from './props/y-tick-format/set.js';
import __var_61__ from './props/y-tick-format/get.js';
import __var_62__ from './props/x-num-ticks/set.js';
import __var_63__ from './props/x-num-ticks/get.js';
import __var_64__ from './props/y-num-ticks/set.js';
import __var_65__ from './props/y-num-ticks/get.js';
import __var_66__ from './props/x-axis-orient/set.js';
import __var_67__ from './props/x-axis-orient/get.js';
import __var_68__ from './props/y-axis-orient/set.js';
import __var_69__ from './props/y-axis-orient/get.js';
import __var_70__ from './props/x-rug/set.js';
import __var_71__ from './props/x-rug/get.js';
import __var_72__ from './props/y-rug/set.js';
import __var_73__ from './props/y-rug/get.js';
import __var_74__ from './props/x-rug-orient/set.js';
import __var_75__ from './props/x-rug-orient/get.js';
import __var_76__ from './props/y-rug-orient/set.js';
import __var_77__ from './props/y-rug-orient/get.js';
import __var_78__ from './props/x-rug-opacity/set.js';
import __var_79__ from './props/x-rug-opacity/get.js';
import __var_80__ from './props/y-rug-opacity/set.js';
import __var_81__ from './props/y-rug-opacity/get.js';
import __var_82__ from './props/x-rug-size/set.js';
import __var_83__ from './props/x-rug-size/get.js';
import __var_84__ from './props/y-rug-size/set.js';
import __var_85__ from './props/y-rug-size/get.js';
import __var_86__ from './props/description/set.js';
import __var_87__ from './props/description/get.js';
import __var_88__ from './props/title/set.js';
import __var_89__ from './props/title/get.js';
import __var_90__ from './props/x-label/set.js';
import __var_91__ from './props/x-label/get.js';
import __var_92__ from './props/y-label/set.js';
import __var_93__ from './props/y-label/get.js';
import __var_94__ from './props/engine/set.js';
import __var_95__ from './props/engine/get.js';
import __var_96__ from './props/auto-render/set.js';
import __var_97__ from './props/auto-render/get.js';
import __var_98__ from './props/render-format/set.js';
import __var_99__ from './props/render-format/get.js';
import __var_100__ from './props/viewer/set.js';
import __var_101__ from './props/viewer/get.js';
import __var_102__ from './props/auto-view/set.js';
import __var_103__ from './props/auto-view/get.js';
import __var_104__ from './props/graph-width/get.js';
import __var_105__ from './props/graph-height/get.js';
import __var_106__ from './props/x-domain/get.js';
import __var_107__ from './props/y-domain/get.js';
import __var_108__ from './props/x-range/get.js';
import __var_109__ from './props/y-range/get.js';
import __var_110__ from './props/x-pos/get.js';
import __var_111__ from './props/y-pos/get.js';
import __var_112__ from './render/index.js';
import __var_113__ from './view/index.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';
var EventEmitter = __var_0__.EventEmitter;
var logger = __var_1__;
var objectKeys = __var_2__;
var defineProperty = __var_3__;
var setReadOnly = __var_4__;
var isObject = __var_5__;
var copy = __var_6__;
var inherit = __var_7__;
var mergeFcn = __var_8__.factory;
var minstd = __var_9__;
var view = __var_10__;
var defaults = __var_11__;
var setX = __var_12__;
var getX = __var_13__;
var setY = __var_14__;
var getY = __var_15__;
var setLabels = __var_16__;
var getLabels = __var_17__;
var setIsDefined = __var_18__;
var getIsDefined = __var_19__;
var setColors = __var_20__;
var getColors = __var_21__;
var setLineStyle = __var_22__;
var getLineStyle = __var_23__;
var setLineOpacity = __var_24__;
var getLineOpacity = __var_25__;
var setLineWidth = __var_26__;
var getLineWidth = __var_27__;
var setSymbols = __var_28__;
var getSymbols = __var_29__;
var setSymbolsSize = __var_30__;
var getSymbolsSize = __var_31__;
var setSymbolsOpacity = __var_32__;
var getSymbolsOpacity = __var_33__;
var setWidth = __var_34__;
var getWidth = __var_35__;
var setHeight = __var_36__;
var getHeight = __var_37__;
var setPaddingLeft = __var_38__;
var getPaddingLeft = __var_39__;
var setPaddingRight = __var_40__;
var getPaddingRight = __var_41__;
var setPaddingTop = __var_42__;
var getPaddingTop = __var_43__;
var setPaddingBottom = __var_44__;
var getPaddingBottom = __var_45__;
var setXMin = __var_46__;
var getXMin = __var_47__;
var setXMax = __var_48__;
var getXMax = __var_49__;
var setYMin = __var_50__;
var getYMin = __var_51__;
var setYMax = __var_52__;
var getYMax = __var_53__;
var setXScale = __var_54__;
var getXScale = __var_55__;
var setYScale = __var_56__;
var getYScale = __var_57__;
var setXTickFormat = __var_58__;
var getXTickFormat = __var_59__;
var setYTickFormat = __var_60__;
var getYTickFormat = __var_61__;
var setXNumTicks = __var_62__;
var getXNumTicks = __var_63__;
var setYNumTicks = __var_64__;
var getYNumTicks = __var_65__;
var setXAxisOrient = __var_66__;
var getXAxisOrient = __var_67__;
var setYAxisOrient = __var_68__;
var getYAxisOrient = __var_69__;
var setXRug = __var_70__;
var getXRug = __var_71__;
var setYRug = __var_72__;
var getYRug = __var_73__;
var setXRugOrient = __var_74__;
var getXRugOrient = __var_75__;
var setYRugOrient = __var_76__;
var getYRugOrient = __var_77__;
var setXRugOpacity = __var_78__;
var getXRugOpacity = __var_79__;
var setYRugOpacity = __var_80__;
var getYRugOpacity = __var_81__;
var setXRugSize = __var_82__;
var getXRugSize = __var_83__;
var setYRugSize = __var_84__;
var getYRugSize = __var_85__;
var setDescription = __var_86__;
var getDescription = __var_87__;
var setTitle = __var_88__;
var getTitle = __var_89__;
var setXLabel = __var_90__;
var getXLabel = __var_91__;
var setYLabel = __var_92__;
var getYLabel = __var_93__;
var setEngine = __var_94__;
var getEngine = __var_95__;
var setAutoRender = __var_96__;
var getAutoRender = __var_97__;
var setRenderFormat = __var_98__;
var getRenderFormat = __var_99__;
var setViewer = __var_100__;
var getViewer = __var_101__;
var setAutoView = __var_102__;
var getAutoView = __var_103__;
var getGraphWidth = __var_104__;
var getGraphHeight = __var_105__;
var getXDomain = __var_106__;
var getYDomain = __var_107__;
var getXRange = __var_108__;
var getYRange = __var_109__;
var getXPos = __var_110__;
var getYPos = __var_111__;
var render = __var_112__;
var viewMethod = __var_113__;


// VARIABLES //

var debug = logger( 'plot:main' );
var PRIVATE_PROPS = [
	'_autoRender',
	'_autoView',
	'_colors',
	'_description',
	'_engine',
	'_height',
	'_isDefined',
	'_labels',
	'_lineOpacity',
	'_lineStyle',
	'_lineWidth',
	'_paddingBottom',
	'_paddingLeft',
	'_paddingRight',
	'_paddingTop',
	'_renderFormat',
	'_symbols',
	'_symbolsOpacity',
	'_symbolsSize',
	'_title',
	'_viewer',
	'_width',
	'_xAxisOrient',
	'_xData',
	'_xLabel',
	'_xMax',
	'_xMin',
	'_xNumTicks',
	'_xRug',
	'_xRugOpacity',
	'_xRugOrient',
	'_xRugSize',
	'_xScale',
	'_xTickFormat',
	'_yAxisOrient',
	'_yData',
	'_yLabel',
	'_yMax',
	'_yMin',
	'_yNumTicks',
	'_yRug',
	'_yRugOpacity',
	'_yRugOrient',
	'_yRugSize',
	'_yScale',
	'_yTickFormat'
];


// FUNCTIONS //

var merge = mergeFcn({
	'extend': false
});


// MAIN //

/**
* Plot constructor.
*
* @constructor
* @param {Array} [x] - x-values
* @param {Array} [y] - y-values
* @param {Options} [options] - constructor options
* @param {boolean} [options.autoRender=false] - indicates whether to re-render on a change event
* @param {boolean} [options.autoView=false] - indicates whether to generate an updated view on a render event
* @param {(string|StringArray)} [options.colors='category10'] - data colors
* @param {string} [options.description=''] - plot description
* @param {string} [options.engine='svg'] - plot engine
* @param {PositiveNumber} [options.height=400] - plot height
* @param {Function} [options.isDefined] - accessor indicating whether a datum is defined
* @param {(StringArray|EmptyArray)} [options.labels] - data labels
* @param {(number|NumberArray)} [options.lineOpacity=0.9] - data line opacity
* @param {(string|StringArray)} [options.lineStyle='-'] - data line style(s)
* @param {(NonNegativeInteger|Array<NonNegativeInteger>)} [options.lineWidth=2] - data line width(s)
* @param {NonNegativeInteger} [options.paddingBottom=80] - bottom padding
* @param {NonNegativeInteger} [options.paddingLeft=90] - left padding
* @param {NonNegativeInteger} [options.paddingRight=20] - right padding
* @param {NonNegativeInteger} [options.paddingTop=80] - top padding
* @param {string} [options.renderFormat='vdom'] - plot render format
* @param {(string|StringArray)} [options.symbols='none'] - data symbols
* @param {(number|NumberArray)} [options.symbolsOpacity=0.9] - symbols opacity
* @param {(NonNegativeInteger|Array<NonNegativeInteger>)} [options.symbolsSize=6] - symbols size
* @param {string} [options.title=''] - plot title
* @param {string} [options.viewer='none'] - plot viewer
* @param {PositiveNumber} [options.width=400] - plot width
* @param {Array} [options.x=[]] - x-values
* @param {string} [options.xAxisOrient='bottom'] - x-axis orientation
* @param {string} [options.xLabel='x'] - x-axis label
* @param {(Date|FiniteNumber|null)} [options.xMax=null] - maximum value of x-axis domain
* @param {(Date|FiniteNumber|null)} [options.xMin=null] - minimum value of x-axis domain
* @param {(NonNegativeInteger|null)} [options.xNumTicks=5] - number of x-axis tick marks
* @param {(boolean|BooleanArray)} [options.xRug=false] - indicates whether to render a rug plot along the x-axis
* @param {(string|StringArray)} [options.xRugOrient='bottom'] - x-axis rug orientation
* @param {(number|NumberArray)} [options.xRugOpacity=0.1] - x-axis rug opacity
* @param {(NonNegativeInteger|Array<NonNegativeInteger>)} [options.xRugSize=6] - x-axis rug tick (tassel) size
* @param {string} [options.xScale='linear'] - x-axis scale
* @param {(string|null)} [options.xTickFormat=null] - x-axis tick format
* @param {Array} [options.y=[]] - y-values
* @param {string} [options.yAxisOrient='left'] - y-axis orientation
* @param {string} [options.yLabel='y'] - y-axis label
* @param {(FiniteNumber|null)} [options.yMax=null] - maximum value of y-axis domain
* @param {(FiniteNumber|null)} [options.yMin=null] - minimum value of y-axis domain
* @param {(NonNegativeInteger|null)} [options.yNumTicks=5] - number of y-axis tick marks
* @param {(boolean|BooleanArray)} [options.yRug=false] - indicates whether to render a rug plot along the y-axis
* @param {(string|StringArray)} [options.yRugOrient='left'] - y-axis rug orientation
* @param {(number|NumberArray)} [options.yRugOpacity=0.1] - y-axis rug opacity
* @param {(NonNegativeInteger|Array<NonNegativeInteger>)} [options.yRugSize=6] - y-axis rug tick (tassel) size
* @param {string} [options.yScale='linear'] - y-axis scale
* @param {(string|null)} [options.yTickFormat=null] - y-axis tick format
* @throws {TypeError} must provide valid options
* @returns {Plot} Plot instance
*
* @example
* var plot = new Plot();
*/
function Plot() {
	var options;
	var nargs;
	var keys;
	var self;
	var opts;
	var key;
	var i;

	nargs = arguments.length;
	if ( !(this instanceof Plot) ) {
		if ( nargs === 0 ) {
			return new Plot();
		}
		if ( nargs === 1 ) {
			return new Plot( arguments[0] );
		}
		if ( nargs === 2 ) {
			return new Plot( arguments[0], arguments[1] );
		}
		return new Plot( arguments[0], arguments[1], arguments[2] );
	}
	self = this;

	opts = defaults();
	if ( nargs === 0 ) {
		options = {};
	} else if ( nargs === 1 ) {
		options = arguments[ 0 ];
		if ( !isObject( options ) ) {
			throw new TypeError( 'invalid argument. Options argument must be an `object`. Value: `' + options + '`.' );
		}
	} else if ( nargs === 2 ) {
		options = {
			'x': arguments[ 0 ],
			'y': arguments[ 1 ]
		};
	} else if ( nargs > 2 ) {
		if ( !isObject( arguments[2] ) ) {
			throw new TypeError( 'invalid argument. Options argument must be an `object`. Value: `' + arguments[2] + '`.' );
		}
		options = copy( arguments[2] ); // avoid mutation
		options.x = arguments[ 0 ];
		options.y = arguments[ 1 ];
	}
	opts = merge( opts, options );

	debug( 'Creating an instance with the following configuration: %s.', JSON.stringify( opts ) );
	EventEmitter.call( this );

	for ( i = 0; i < PRIVATE_PROPS.length; i++ ) {
		defineProperty( this, PRIVATE_PROPS[i], {
			'configurable': false,
			'enumerable': false,
			'writable': true,
			'value': null
		});
	}
	// Set a clipping path id:
	defineProperty( this, '_clipPathId', {
		'configurable': false,
		'enumerable': false,
		'writable': false,
		'value': minstd().toString() // TODO: uuid
	});

	// Initialize an internal cache for renderers...
	defineProperty( this, '$', {
		'configurable': false,
		'enumerable': false,
		'writable': false,
		'value': {}
	});
	defineProperty( this.$, 'svg', {
		'configurable': false,
		'enumerable': false,
		'writable': false,
		'value': {}
	});

	// Set options...
	keys = objectKeys( opts );
	for ( i = 0; i < keys.length; i++ ) {
		key = keys[ i ];
		this[ key ] = opts[ key ];
	}

	// Add event listeners:
	this.on( 'change', onChange );
	this.on( 'render', onRender );

	return this;

	/**
	* Callback invoked upon receiving a change event.
	*
	* @private
	*/
	function onChange() {
		/* eslint-disable no-underscore-dangle */
		debug( 'Received a change event.' );
		if ( self._autoRender ) {
			self.render();
		}
	}

	/**
	* Callback invoked upon receiving a render event.
	*
	* @private
	* @param {*} plot - rendered plot
	*/
	function onRender( plot ) {
		/* eslint-disable no-underscore-dangle */
		debug( 'Received a render event.' );
		if ( self._autoView ) {
			debug( 'Viewer: %s.', self._viewer );
			debug( 'Generating view...' );
			view( self, self._viewer, plot );
		}
	}
}

/*
* Inherit from the `EventEmitter` prototype.
*/
inherit( Plot, EventEmitter );

/**
* `x` values.
*
* @name x
* @memberof Plot.prototype
* @type {Array}
* @throws {TypeError} must be an array
* @default []
*
* @example
* var plot = new Plot();
* plot.x = [ [ 1417563950959, 1417563952959 ] ];
*
* @example
* var plot = new Plot({
*     'x': [ [ 1417563950959, 1417563952959 ] ]
* });
* var x = plot.x;
* // returns [ [ 1417563950959, 1417563952959 ] ]
*/
defineProperty( Plot.prototype, 'x', {
	'configurable': false,
	'enumerable': true,
	'set': setX,
	'get': getX
});

/**
* `y` values.
*
* @name y
* @memberof Plot.prototype
* @type {Array}
* @throws {TypeError} must be an array
* @default []
*
* @example
* var plot = new Plot();
* plot.x = [ [ 1417563950959, 1417563952959 ] ];
* plot.y = [ [ 0.25, 0.23 ] ];
*
* @example
* var plot = new Plot({
*     'x': [ [ 1417563950959, 1417563952959 ] ],
*     'y': [ [ 0.25, 0.23 ] ]
* });
* var y = plot.y;
* // returns [ [ 0.25, 0.23 ] ]
*/
defineProperty( Plot.prototype, 'y', {
	'configurable': false,
	'enumerable': true,
	'set': setY,
	'get': getY
});

/**
* Data labels.
*
* @name labels
* @memberof Plot.prototype
* @type {(StringArray|EmptyArray)}
* @throws {TypeError} must be either an array of strings or an empty array
* @default []
*
* @example
* var plot = new Plot();
* plot.labels = [ 'beep', 'boop' ];
*
* @example
* var plot = new Plot({
*     'labels': [ 'beep', 'boop' ]
* });
* var labels = plot.labels;
* // returns [ 'beep', 'boop' ]
*/
defineProperty( Plot.prototype, 'labels', {
	'configurable': false,
	'enumerable': true,
	'set': setLabels,
	'get': getLabels
});

/**
* Accessor which defines whether a datum is defined.
*
* ## Notes
*
* -   This accessor is used to define how missing values are encoded.
* -   The default behavior is to ignore values which are `NaN`.
*
* @name isDefined
* @memberof Plot.prototype
* @type {Function}
* @param {*} d - datum
* @param {integer} i - index
* @throws {TypeError} must be a function
*
* @example
* var plot = new Plot();
* plot.isDefined = function isDefined( d ) {
*     // Check for `NaN`:
*     return ( d === d );
* }
*
* @example
* function isDefined( d ) {
*     // Check for `NaN`:
*     return ( d === d );
* }
* var plot = new Plot({
*     'isDefined': isDefined
* });
* var fcn = plot.isDefined;
* // returns <Function>
*/
defineProperty( Plot.prototype, 'isDefined', {
	'configurable': false,
	'enumerable': true,
	'set': setIsDefined,
	'get': getIsDefined
});

/**
* Data colors. When retrieved, the returned value is always an `array`.
*
* @name colors
* @memberof Plot.prototype
* @type {(string|StringArray)}
* @throws {TypeError} must be either a string or an array of strings
* @default 'category10'
*
* @example
* var plot = new Plot();
* plot.colors = 'category20';
*
* @example
* var plot = new Plot({
*     'colors': 'category20'
* });
* var colors = plot.colors;
* // returns [...]
*/
defineProperty( Plot.prototype, 'colors', {
	'configurable': false,
	'enumerable': true,
	'set': setColors,
	'get': getColors
});

/**
* Data line style(s).
*
* ## Notes
*
* -   When retrieved, the returned value is always an `array`.
*
* @name lineStyle
* @memberof Plot.prototype
* @type {(string|StringArray)}
* @throws {TypeError} must be a string or string array
* @throws {Error} must be a supported line style
* @default '-'
*
* @example
* var plot = new Plot();
* plot.lineStyle = [ '-', 'none' ];
*
* @example
* var plot = new Plot({
*     'lineStyle': 'none'
* });
* var lineStyle = plot.lineStyle;
* // returns [ 'none' ]
*/
defineProperty( Plot.prototype, 'lineStyle', {
	'configurable': false,
	'enumerable': true,
	'set': setLineStyle,
	'get': getLineStyle
});

/**
* Data line opacity.
*
* ## Notes
*
* -   When retrieved, the returned value is always an `array`.
*
* @name lineOpacity
* @memberof Plot.prototype
* @type {(number|NumberArray)}
* @throws {TypeError} must be a number or number array
* @throws {RangeError} must be a number on the interval `[0,1]`
* @default '0.9'
*
* @example
* var plot = new Plot();
* plot.lineOpacity = [ 1.0, 0.5 ];
*
* @example
* var plot = new Plot({
*     'lineOpacity': 0.5
* });
* var opacity = plot.lineOpacity;
* // returns [ 0.5 ]
*/
defineProperty( Plot.prototype, 'lineOpacity', {
	'configurable': false,
	'enumerable': true,
	'set': setLineOpacity,
	'get': getLineOpacity
});

/**
* Data line width.
*
* ## Notes
*
* -   When retrieved, the returned value is always an `array`.
*
* @name lineWidth
* @memberof Plot.prototype
* @type {(NonNegativeInteger|NonNegativeIntegerArray)}
* @throws {TypeError} must be a nonnegative integer or nonnegative integer array
* @default 2
*
* @example
* var plot = new Plot();
* plot.lineWidth = 1;
*
* @example
* var plot = new Plot({
*     'lineWidth': [ 1, 3 ]
* });
* var width = plot.lineWidth;
* // returns [ 1, 3 ]
*/
defineProperty( Plot.prototype, 'lineWidth', {
	'configurable': false,
	'enumerable': true,
	'set': setLineWidth,
	'get': getLineWidth
});

/**
* Data symbols. When retrieved, the returned value is always an `array`.
*
* @name symbols
* @memberof Plot.prototype
* @type {(string|StringArray)}
* @throws {TypeError} must be a string or string array
* @throws {Error} must be a supported symbol
* @default 'none'
*
* @example
* var plot = new Plot();
* plot.symbols = [ 'open-circle', 'closed-circle' ];
*
* @example
* var plot = new Plot({
*     'symbols': 'closed-circle'
* });
* var symbols = plot.symbols;
* // returns [ 'closed-circle' ]
*/
defineProperty( Plot.prototype, 'symbols', {
	'configurable': false,
	'enumerable': true,
	'set': setSymbols,
	'get': getSymbols
});

/**
* Symbols size. When retrieved, the returned value is always an `array`.
*
* @name symbolsSize
* @memberof Plot.prototype
* @type {(NonNegativeInteger|NonNegativeIntegerArray)}
* @throws {TypeError} must be a nonnegative integer or nonnegative integer array
* @default 6
*
* @example
* var plot = new Plot();
* plot.symbolsSize = 4;
*
* @example
* var plot = new Plot({
*     'symbolsSize': [ 4, 6 ]
* });
* var size = plot.symbolsSize;
* // returns [ 4, 6 ]
*/
defineProperty( Plot.prototype, 'symbolsSize', {
	'configurable': false,
	'enumerable': true,
	'set': setSymbolsSize,
	'get': getSymbolsSize
});

/**
* Symbols opacity. When retrieved, the returned value is always an `array`.
*
* @name symbolsOpacity
* @memberof Plot.prototype
* @type {(number|NumberArray)}
* @throws {TypeError} must be a number or number array
* @throws {RangeError} must be a number on the interval `[0,1]`
* @default 0.9
*
* @example
* var plot = new Plot();
* plot.symbolsOpacity = [ 0.2, 0.5 ];
*
* @example
* var plot = new Plot({
*     'symbolsOpacity': 0.2
* });
* var opacity = plot.symbolsOpacity;
* // returns [ 0.2 ]
*/
defineProperty( Plot.prototype, 'symbolsOpacity', {
	'configurable': false,
	'enumerable': true,
	'set': setSymbolsOpacity,
	'get': getSymbolsOpacity
});

/**
* Plot width.
*
* @name width
* @memberof Plot.prototype
* @type {PositiveNumber}
* @throws {TypeError} must be a positive number
* @default 400 (px)
*
* @example
* var plot = new Plot();
* plot.width = 100;
*
* @example
* var plot = new Plot({
*     'width': 480
* });
* var width = plot.width;
* // returns 480
*/
defineProperty( Plot.prototype, 'width', {
	'configurable': false,
	'enumerable': true,
	'set': setWidth,
	'get': getWidth
});

/**
* Plot height.
*
* @name height
* @memberof Plot.prototype
* @type {PositiveNumber}
* @throws {TypeError} must be a positive number
* @default 400 (px)
*
* @example
* var plot = new Plot();
* plot.height = 100;
*
* @example
* var plot = new Plot({
*     'height': 360
* });
* var height = plot.height;
* // returns 360
*/
defineProperty( Plot.prototype, 'height', {
	'configurable': false,
	'enumerable': true,
	'set': setHeight,
	'get': getHeight
});

/**
* Plot left padding.
*
* ## Notes
*
* -   Typically used to create space for a left-oriented y-axis.
*
* @name paddingLeft
* @memberof Plot.prototype
* @type {NonNegativeInteger}
* @throws {TypeError} must be a nonnegative integer
* @default 90 (px)
*
* @example
* var plot = new Plot();
* plot.paddingLeft = 100;
*
* @example
* var plot = new Plot({
*     'paddingLeft': 100
* });
* var padding = plot.paddingLeft;
* // returns 100
*/
defineProperty( Plot.prototype, 'paddingLeft', {
	'configurable': false,
	'enumerable': true,
	'set': setPaddingLeft,
	'get': getPaddingLeft
});

/**
* Plot right padding.
*
* ## Notes
*
* -   Typically used to create space for a right-oriented y-axis.
*
* @name paddingRight
* @memberof Plot.prototype
* @type {NonNegativeInteger}
* @throws {TypeError} must be a nonnegative integer
* @default 20 (px)
*
* @example
* var plot = new Plot();
* plot.paddingRight = 100;
*
* @example
* var plot = new Plot({
*     'paddingRight': 100
* });
* var padding = plot.paddingRight;
* // returns 100
*/
defineProperty( Plot.prototype, 'paddingRight', {
	'configurable': false,
	'enumerable': true,
	'set': setPaddingRight,
	'get': getPaddingRight
});

/**
* Plot top padding.
*
* ## Notes
*
* -   Typically used to create space for a title or top-oriented x-axis.
*
* @name paddingTop
* @memberof Plot.prototype
* @type {NonNegativeInteger}
* @throws {TypeError} must be a nonnegative integer
* @default 80 (px)
*
* @example
* var plot = new Plot();
* plot.paddingTop = 100;
*
* @example
* var plot = new Plot({
*     'paddingTop': 100
* });
* var padding = plot.paddingTop;
* // returns 100
*/
defineProperty( Plot.prototype, 'paddingTop', {
	'configurable': false,
	'enumerable': true,
	'set': setPaddingTop,
	'get': getPaddingTop
});

/**
* Plot bottom padding.
*
* ## Notes
*
* -   Typically used to create space for a bottom-oriented y-axis.
*
* @name paddingBottom
* @memberof Plot.prototype
* @type {NonNegativeInteger}
* @throws {TypeError} must be a nonnegative integer
* @default 80 (px)
*
* @example
* var plot = new Plot();
* plot.paddingBottom = 100;
*
* @example
* var plot = new Plot({
*     'paddingBottom': 100
* });
* var padding = plot.paddingBottom;
* // returns 100
*/
defineProperty( Plot.prototype, 'paddingBottom', {
	'configurable': false,
	'enumerable': true,
	'set': setPaddingBottom,
	'get': getPaddingBottom
});

/**
* Minimum value of the x-axis domain.
*
* ## Notes
*
* -   When retrieved, if the value has been set to `null`, the returned value is computed from the `x` data.
*
* @name xMin
* @memberof Plot.prototype
* @type {(FiniteNumber|null)}
* @throws {TypeError} must be a finite number primitive or null
* @default null
*
* @example
* var plot = new Plot();
* plot.xMin = -1.0;
*
* @example
* var plot = new Plot({
*     'xMin': -10.0
* });
* var xmin = plot.xMin;
* // returns -10.0
*/
defineProperty( Plot.prototype, 'xMin', {
	'configurable': false,
	'enumerable': true,
	'set': setXMin,
	'get': getXMin
});

/**
* Maximum value of the x-axis domain.
*
* ## Notes
*
* -   When retrieved, if the value has been set to `null`, the returned value is computed from the `x` data.
*
* @name xMax
* @memberof Plot.prototype
* @type {(FiniteNumber|null)}
* @throws {TypeError} must be a finite number primitive or null
* @default null
*
* @example
* var plot = new Plot();
* plot.xMax = 100.0;
*
* @example
* var plot = new Plot({
*     'xMax': 10.0
* });
* var xmax = plot.xMax;
* // returns 10.0
*/
defineProperty( Plot.prototype, 'xMax', {
	'configurable': false,
	'enumerable': true,
	'set': setXMax,
	'get': getXMax
});

/**
* Minimum value of the y-axis domain.
*
* ## Notes
*
* -   When retrieved, if the value has been set to `null`, the returned value is computed from the `y` data.
*
* @name yMin
* @memberof Plot.prototype
* @type {(FiniteNumber|null)}
* @throws {TypeError} must be a finite number primitive or null
* @default null
*
* @example
* var plot = new Plot();
* plot.yMin = -100.0;
*
* @example
* var plot = new Plot({
*     'yMin': 3.14
* });
* var ymin = plot.yMin;
* // returns 3.14
*/
defineProperty( Plot.prototype, 'yMin', {
	'configurable': false,
	'enumerable': true,
	'set': setYMin,
	'get': getYMin
});

/**
* Maximum value of the y-axis domain.
*
* ## Notes
*
* -   When retrieved, if the value has been set to `null`, the returned value is computed from the `y` data.
*
* @name yMax
* @memberof Plot.prototype
* @type {(FiniteNumber|null)}
* @throws {TypeError} must be a finite number primitive or null
* @default null
*
* @example
* var plot = new Plot();
* plot.yMax = 100.0;
*
* @example
* var plot = new Plot({
*     'yMax': 31.4
* });
* var ymax = plot.yMax;
* // returns 31.4
*/
defineProperty( Plot.prototype, 'yMax', {
	'configurable': false,
	'enumerable': true,
	'set': setYMax,
	'get': getYMax
});

/**
* Scale function for mapping values to a coordinate along the x-axis. When retrieved, the returned value is a scale function.
*
* @name xScale
* @memberof Plot.prototype
* @type {string}
* @throws {TypeError} must be a string primitive
* @default 'linear'
*
* @example
* var plot = new Plot();
* plot.xScale = 'time';
*
* @example
* var plot = new Plot({
*     'xScale': 'time'
* });
* var scale = plot.xScale;
* // returns <Function>
*/
defineProperty( Plot.prototype, 'xScale', {
	'configurable': false,
	'enumerable': true,
	'set': setXScale,
	'get': getXScale
});

/**
* Scale function for mapping values to a coordinate along the y-axis. When retrieved, the returned value is a scale function.
*
* @name yScale
* @memberof Plot.prototype
* @type {string}
* @throws {TypeError} must be a string primitive
* @default 'linear'
*
* @example
* var plot = new Plot();
* plot.yScale = 'linear';
*
* @example
* var plot = new Plot({
*     'yScale': 'linear'
* });
* var scale = plot.yScale;
* // returns <Function>
*/
defineProperty( Plot.prototype, 'yScale', {
	'configurable': false,
	'enumerable': true,
	'set': setYScale,
	'get': getYScale
});

/**
* x-axis tick format.
*
* ## Notes
*
* -   When retrieved, if the value is not `null`, the returned value is a formatting function.
*
* @name xTickFormat
* @memberof Plot.prototype
* @type {(string|null)}
* @throws {TypeError} must be a string primitive or null
* @default null
*
* @example
* var plot = new Plot();
* plot.xScale = 'time';
* plot.xTickFormat = '%H:%M';
*
* @example
* var plot = new Plot({
*     'xScale': 'time',
*     'xTickFormat': '%H:%M'
* });
* var fmt = plot.xTickFormat;
* // returns <Function>
*/
defineProperty( Plot.prototype, 'xTickFormat', {
	'configurable': false,
	'enumerable': true,
	'set': setXTickFormat,
	'get': getXTickFormat
});

/**
* y-axis tick format.
*
* ## Notes
*
* -   If the value is not `null`, when retrieved, the returned value is a formatting function.
*
* @name yTickFormat
* @memberof Plot.prototype
* @type {(string|null)}
* @throws {TypeError} must be a string primitive or null
* @default null
*
* @example
* var plot = new Plot();
* plot.yTickFormat = '.0%';
*
* @example
* var plot = new Plot({
*     'yTickFormat': '.0%'
* });
* var fmt = plot.yTickFormat;
* // returns <Function>
*/
defineProperty( Plot.prototype, 'yTickFormat', {
	'configurable': false,
	'enumerable': true,
	'set': setYTickFormat,
	'get': getYTickFormat
});

/**
* Number of x-axis tick marks.
*
* @name xNumTicks
* @memberof Plot.prototype
* @type {(NonNegativeInteger|null)}
* @throws {TypeError} must be a nonnegative integer or null
* @default 5
*
* @example
* var plot = new Plot();
* plot.xNumTicks = 10;
*
* @example
* var plot = new Plot({
*     'xNumTicks': 10
* });
* var ticks = plot.xNumTicks;
* // returns 10
*/
defineProperty( Plot.prototype, 'xNumTicks', {
	'configurable': false,
	'enumerable': true,
	'set': setXNumTicks,
	'get': getXNumTicks
});

/**
* Number of y-axis tick marks.
*
* @name yNumTicks
* @memberof Plot.prototype
* @type {(NonNegativeInteger|null)}
* @throws {TypeError} must be a nonnegative integer or null
* @default 5
*
* @example
* var plot = new Plot();
* plot.yNumTicks = 10;
*
* @example
* var plot = new Plot({
*     'yNumTicks': 10
* });
* var ticks = plot.yNumTicks;
* // returns 10
*/
defineProperty( Plot.prototype, 'yNumTicks', {
	'configurable': false,
	'enumerable': true,
	'set': setYNumTicks,
	'get': getYNumTicks
});

/**
* x-axis orientation.
*
* @name xAxisOrient
* @memberof Plot.prototype
* @type {string}
* @throws {TypeError} must be either `'top'` or `'bottom'`
* @default 'bottom'
*
* @example
* var plot = new Plot();
* plot.xAxisOrient = 'bottom';
*
* @example
* var plot = new Plot({
*     'xAxisOrient': 'bottom'
* });
* var orientation = plot.xAxisOrient;
* // returns 'bottom'
*/
defineProperty( Plot.prototype, 'xAxisOrient', {
	'configurable': false,
	'enumerable': true,
	'set': setXAxisOrient,
	'get': getXAxisOrient
});

/**
* y-axis orientation.
*
* @name yAxisOrient
* @memberof Plot.prototype
* @type {string}
* @throws {TypeError} must be either `'left'` or `'right'`
* @default 'left'
*
* @example
* var plot = new Plot();
* plot.yAxisOrient = 'left';
*
* @example
* var plot = new Plot({
*     'yAxisOrient': 'left'
* });
* var orientation = plot.yAxisOrient;
* // returns 'left'
*/
defineProperty( Plot.prototype, 'yAxisOrient', {
	'configurable': false,
	'enumerable': true,
	'set': setYAxisOrient,
	'get': getYAxisOrient
});

/**
* Boolean flag(s) indicating whether to display a rug plot along the x-axis. When retrieved, the returned value is always an `array`.
*
* @name xRug
* @memberof Plot.prototype
* @type {(boolean|BooleanArray)}
* @throws {TypeError} must be a boolean primitive or boolean array
* @default false
*
* @example
* var plot = new Plot({
*     'xRug': true
* });
*
* var bool = plot.xRug;
* // returns [ true ]
*/
defineProperty( Plot.prototype, 'xRug', {
	'configurable': false,
	'enumerable': true,
	'set': setXRug,
	'get': getXRug
});

/**
* Boolean flag(s) indicating whether to display a rug plot along the y-axis. When retrieved, the returned value is always an `array`.
*
* @name yRug
* @memberof Plot.prototype
* @type {(boolean|BooleanArray)}
* @throws {TypeError} must be a boolean primitive or boolean array
* @default false
*
* @example
* var plot = new Plot({
*     'yRug': true
* });
*
* var bool = plot.yRug;
* // returns [ true ]
*/
defineProperty( Plot.prototype, 'yRug', {
	'configurable': false,
	'enumerable': true,
	'set': setYRug,
	'get': getYRug
});

/**
* x-axis rug orientation. When retrieved, the returned value is always an `array`.
*
* @name xRugOrient
* @memberof Plot.prototype
* @type {(string|StringArray)}
* @throws {TypeError} must be a string or string array
* @throws {TypeError} must be either `'top'` or `'bottom'`
* @default 'bottom'
*
* @example
* var plot = new Plot();
* plot.xRugOrient = [ 'bottom', 'top' ];
*
* @example
* var plot = new Plot({
*     'xRugOrient': 'bottom'
* });
* var orientation = plot.xRugOrient;
* // returns [ 'bottom' ]
*/
defineProperty( Plot.prototype, 'xRugOrient', {
	'configurable': false,
	'enumerable': true,
	'set': setXRugOrient,
	'get': getXRugOrient
});

/**
* y-axis rug orientation. When retrieved, the returned value is always an `array`.
*
* @name yRugOrient
* @memberof Plot.prototype
* @type {(string|StringArray)}
* @throws {TypeError} must be a string or string array
* @throws {TypeError} must be either `'left'` or `'right'`
* @default 'left'
*
* @example
* var plot = new Plot();
* plot.yRugOrient = [ 'right', 'left' ];
*
* @example
* var plot = new Plot({
*     'yRugOrient': 'left'
* });
* var orientation = plot.yRugOrient;
* // returns [ 'left' ]
*/
defineProperty( Plot.prototype, 'yRugOrient', {
	'configurable': false,
	'enumerable': true,
	'set': setYRugOrient,
	'get': getYRugOrient
});

/**
* x-axis rug opacity. When retrieved, the returned value is always an `array`.
*
* @name xRugOpacity
* @memberof Plot.prototype
* @type {(number|NumberArray)}
* @throws {TypeError} must be a number or number array
* @throws {RangeError} must be a number on the interval `[0,1]`
* @default 0.1
*
* @example
* var plot = new Plot();
* plot.xRugOpacity = [ 0.1, 0.5 ];
*
* @example
* var plot = new Plot({
*     'xRugOpacity': 0.1
* });
* var opacity = plot.xRugOpacity;
* // returns [ 0.1 ]
*/
defineProperty( Plot.prototype, 'xRugOpacity', {
	'configurable': false,
	'enumerable': true,
	'set': setXRugOpacity,
	'get': getXRugOpacity
});

/**
* y-axis rug opacity. When retrieved, the returned value is always an `array`.
*
* @name yRugOpacity
* @memberof Plot.prototype
* @type {(number|NumberArray)}
* @throws {TypeError} must be a number or number array
* @throws {RangeError} must be a number on the interval `[0,1]`
* @default 0.1
*
* @example
* var plot = new Plot();
* plot.yRugOpacity = [ 0.1, 0.5 ];
*
* @example
* var plot = new Plot({
*     'yRugOpacity': 0.1
* });
* var opacity = plot.yRugOpacity;
* // returns [ 0.1 ]
*/
defineProperty( Plot.prototype, 'yRugOpacity', {
	'configurable': false,
	'enumerable': true,
	'set': setYRugOpacity,
	'get': getYRugOpacity
});

/**
* x-axis rug tick (tassel) size. When retrieved, the returned value is always an `array`.
*
* @name xRugSize
* @memberof Plot.prototype
* @type {(NonNegativeInteger|Array<NonNegativeInteger>)}
* @throws {TypeError} must be a nonnegative integer or nonnegative integer array
* @default 6
*
* @example
* var plot = new Plot();
* plot.xRugSize = [ 4, 6 ];
*
* @example
* var plot = new Plot({
*     'xRugSize': 4
* });
* var size = plot.xRugSize;
* // returns [ 4 ]
*/
defineProperty( Plot.prototype, 'xRugSize', {
	'configurable': false,
	'enumerable': true,
	'set': setXRugSize,
	'get': getXRugSize
});

/**
* y-axis rug tick (tassel) size. When retrieved, the returned value is always an `array`.
*
* @name yRugSize
* @memberof Plot.prototype
* @type {(NonNegativeInteger|Array<NonNegativeInteger>)}
* @throws {TypeError} must be a nonnegative integer or nonnegative integer array
* @default 6
*
* @example
* var plot = new Plot();
* plot.yRugSize = [ 4, 6 ];
*
* @example
* var plot = new Plot({
*     'yRugSize': 4
* });
* var size = plot.yRugSize;
* // returns [ 4 ]
*/
defineProperty( Plot.prototype, 'yRugSize', {
	'configurable': false,
	'enumerable': true,
	'set': setYRugSize,
	'get': getYRugSize
});

/**
* Plot description.
*
* @name description
* @memberof Plot.prototype
* @type {string}
* @throws {TypeError} must be a string primitive
* @default ''
*
* @example
* var plot = new Plot();
* plot.description = 'Average stock market index covering the last 100 years.';
*
* @example
* var plot = new Plot({
*     'description': 'A plot description.'
* });
* var desc = plot.description;
* // returns 'A plot description.'
*/
defineProperty( Plot.prototype, 'description', {
	'configurable': false,
	'enumerable': true,
	'set': setDescription,
	'get': getDescription
});

/**
* Plot title.
*
* @name title
* @memberof Plot.prototype
* @type {string}
* @throws {TypeError} must be a string primitive
* @default ''
*
* @example
* var plot = new Plot();
* plot.title = 'Time Series';
*
* @example
* var plot = new Plot({
*     'title': 'Time Series'
* });
* var t = plot.title;
* // returns 'Time Series'
*/
defineProperty( Plot.prototype, 'title', {
	'configurable': false,
	'enumerable': true,
	'set': setTitle,
	'get': getTitle
});

/**
* x-axis label.
*
* @name xLabel
* @memberof Plot.prototype
* @type {string}
* @throws {TypeError} must be a string primitive
* @default 'x'
*
* @example
* var plot = new Plot();
* plot.xLabel = 'time';
*
* @example
* var plot = new Plot({
*     'xLabel': 'time'
* });
* var xLabel = plot.xLabel;
* // returns 'time'
*/
defineProperty( Plot.prototype, 'xLabel', {
	'configurable': false,
	'enumerable': true,
	'set': setXLabel,
	'get': getXLabel
});

/**
* y-axis label.
*
* @name yLabel
* @memberof Plot.prototype
* @type {string}
* @throws {TypeError} must be a string primitive
* @default 'y'
*
* @example
* var plot = new Plot();
* plot.yLabel = 'value';
*
* @example
* var plot = new Plot({
*     'yLabel': 'value'
* });
* var yLabel = plot.yLabel;
* // returns 'value'
*/
defineProperty( Plot.prototype, 'yLabel', {
	'configurable': false,
	'enumerable': true,
	'set': setYLabel,
	'get': getYLabel
});

/**
* Plot engine.
*
* @name engine
* @memberof Plot.prototype
* @type {string}
* @throws {TypeError} must be a recognized engine
* @default 'svg'
*
* @example
* var plot = new Plot();
* plot.engine = 'svg';
*
* @example
* var plot = new Plot({
*     'engine': 'svg'
* });
* var engine = plot.engine;
* // returns 'svg'
*/
defineProperty( Plot.prototype, 'engine', {
	'configurable': false,
	'enumerable': true,
	'set': setEngine,
	'get': getEngine
});

/**
* Rendering mode.
*
* ## Notes
*
* -   If `true`, an instance re-renders on each change event.
*
* @name autoRender
* @memberof Plot.prototype
* @type {boolean}
* @throws {TypeError} must be a boolean primitive
* @default false
*
* @example
* var plot = new Plot({
*     'autoRender': true
* });
*
* var mode = plot.autoRender;
* // returns true
*/
defineProperty( Plot.prototype, 'autoRender', {
	'configurable': false,
	'enumerable': true,
	'set': setAutoRender,
	'get': getAutoRender
});

/**
* Plot render format.
*
* @name renderFormat
* @memberof Plot.prototype
* @type {string}
* @throws {TypeError} must be a recognized format
* @default 'vdom'
*
* @example
* var plot = new Plot();
* plot.renderFormat = 'vdom';
*
* @example
* var plot = new Plot({
*     'renderFormat': 'html'
* });
* var fmt = plot.renderFormat;
* // returns 'html'
*/
defineProperty( Plot.prototype, 'renderFormat', {
	'configurable': false,
	'enumerable': true,
	'set': setRenderFormat,
	'get': getRenderFormat
});

/**
* Plot viewer.
*
* @name viewer
* @memberof Plot.prototype
* @type {string}
* @throws {TypeError} must be a recognized viewer
* @default 'none'
*
* @example
* var plot = new Plot();
* plot.viewer = 'none';
*
* @example
* var plot = new Plot({
*     'viewer': 'none'
* });
* var viewer = plot.viewer;
* // returns 'none'
*/
defineProperty( Plot.prototype, 'viewer', {
	'configurable': false,
	'enumerable': true,
	'set': setViewer,
	'get': getViewer
});

/**
* Viewer mode. If `true`, an instance generates an updated view on each render event.
*
* @name autoView
* @memberof Plot.prototype
* @type {boolean}
* @throws {TypeError} must be a boolean primitive
* @default false
*
* @example
* var plot = new Plot({
*     'autoView': false
* });
*
* var mode = plot.autoView;
* // returns false
*/
defineProperty( Plot.prototype, 'autoView', {
	'configurable': false,
	'enumerable': true,
	'set': setAutoView,
	'get': getAutoView
});

/**
* Expected graph width.
*
* @name graphWidth
* @memberof Plot.prototype
* @type {number}
*
* @example
* var plot = new Plot({
*     'width': 100,
*     'paddingLeft': 10,
*     'paddingRight': 10
* });
* var width = plot.graphWidth;
* // returns 80
*/
defineProperty( Plot.prototype, 'graphWidth', {
	'configurable': false,
	'enumerable': true,
	'get': getGraphWidth
});

/**
* Expected graph height.
*
* @name graphHeight
* @memberof Plot.prototype
* @type {number}
*
* @example
* var plot = new Plot({
*     'height': 100,
*     'paddingTop': 10,
*     'paddingBottom': 20
* });
* var height = plot.graphHeight;
* // returns 70
*/
defineProperty( Plot.prototype, 'graphHeight', {
	'configurable': false,
	'enumerable': true,
	'get': getGraphHeight
});

/**
* x-axis domain.
*
* @name xDomain
* @memberof Plot.prototype
* @type {Array}
*
* @example
* var plot = new Plot({
*     'xMin': 0,
*     'xMax': 100
* });
* var domain = plot.xDomain;
* // returns [ 0, 100 ]
*/
defineProperty( Plot.prototype, 'xDomain', {
	'configurable': false,
	'enumerable': true,
	'get': getXDomain
});

/**
* y-axis domain.
*
* @name yDomain
* @memberof Plot.prototype
* @type {NumberArray}
*
* @example
* var plot = new Plot({
*     'yMin': 0,
*     'yMax': 100
* });
* var domain = plot.yDomain;
* // returns [ 0, 100 ]
*/
defineProperty( Plot.prototype, 'yDomain', {
	'configurable': false,
	'enumerable': true,
	'get': getYDomain
});

/**
* x-axis range.
*
* @name xRange
* @memberof Plot.prototype
* @type {NumberArray}
*
* @example
* var plot = new Plot({
*     'width': 100,
*     'paddingLeft': 10,
*     'paddingRight': 10
* });
* var range = plot.xRange;
* // returns [ 0, 80 ]
*/
defineProperty( Plot.prototype, 'xRange', {
	'configurable': false,
	'enumerable': true,
	'get': getXRange
});

/**
* y-axis range.
*
* @name yRange
* @memberof Plot.prototype
* @type {NumberArray}
*
* @example
* var plot = new Plot({
*     'height': 100,
*     'paddingTop': 10,
*     'paddingBottom': 20
* });
* var range = plot.yRange;
* // returns [ 70, 0 ]
*/
defineProperty( Plot.prototype, 'yRange', {
	'configurable': false,
	'enumerable': true,
	'get': getYRange
});

/**
* Function to map values to x-axis coordinate values.
*
* @name xPos
* @memberof Plot.prototype
* @type {Function}
*
* @example
* var plot = new Plot();
* var xPos = plot.xPos;
* // returns <Function>
*/
defineProperty( Plot.prototype, 'xPos', {
	'configurable': false,
	'enumerable': true,
	'get': getXPos
});

/**
* Function to map values to y-axis coordinate values.
*
* @name yPos
* @memberof Plot.prototype
* @type {Function}
*
* @example
* var plot = new Plot();
* var yPos = plot.yPos;
* // returns <Function>
*/
defineProperty( Plot.prototype, 'yPos', {
	'configurable': false,
	'enumerable': true,
	'get': getYPos
});

/**
* Renders a plot.
*
* @name render
* @memberof Plot.prototype
* @type {Function}
* @param {string} [format] - render format
* @throws {TypeError} must provide a recognized format
* @returns {(VTree|string)} virtual tree or string
*
* @example
* var plot = new Plot();
* plot.x = [ [ 1, 2, 3 ] ];
* plot.y = [ [ 1, 0, 1 ] ];
*
* var out = plot.render();
*
* @example
* var plot = new Plot();
* plot.x = [ [ 1, 2, 3 ] ];
* plot.y = [ [ 1, 0, 1 ] ];
*
* var out = plot.render( 'html' );
*/
setReadOnly( Plot.prototype, 'render', render );

/**
* Generates a plot view.
*
* @name view
* @memberof Plot.prototype
* @type {Function}
* @param {string} [viewer]
* @throws {TypeError} must provide a recognized viewer
*
* @example
* var plot = new Plot();
* plot.x = [ [ 1, 2, 3 ] ];
* plot.y = [ [ 1, 0, 1 ] ];
*
* plot.view( 'stdout' );
*/
setReadOnly( Plot.prototype, 'view', viewMethod );


// EXPORTS //
export default Plot;
